<template>
    <v-list-group
        :class="{'left-menu-main-list-group': level == 0}"       
        :no-action="level > 0"
        :sub-group="level > 0"
        @click="itemClick(item, 'context')"
        :value="opened"
    >
        <template v-slot:activator>
            <v-list-item-title>{{ getLocalized(item.NameRu, item.NameKz) }}</v-list-item-title>
        </template>
        <template v-slot:appendIcon>
            <v-icon>fas fa-chevron-down</v-icon>
        </template>
        
        <context-tree-view-item
            v-for="(child, idx) in item.ChildContexts"
            :key="child.Id || idx"
            :item="child"
            :level="level+1"
            :itemClick="itemClick"
        />

        <v-list-item
            v-for="(classifier, cidx) in item.Classifiers"
            :key="classifier.Id || cidx"
            :to="{ name: 'DynamicTableView', params: { id: classifier.Id } }"
        >
            <v-list-item-title v-tooltip.right="getLocalized(classifier.NameRu, classifier.NameKz)">{{ getLocalized(classifier.NameRu, classifier.NameKz) }}</v-list-item-title>
        </v-list-item>
    </v-list-group>
        
</template>
  
  <script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'ContextTreeViewItem', 
    props: {
        item: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        initiallyOpen: {
            type: Boolean,
            default: false
        },
        itemClick: {
            type: Function,
            default: null
        }
    },
    computed: {
        ...mapGetters('sep', { openIds: 'getOpened' }),
        hasChildren() {
            return this.item.ChildContexts && this.item.ChildContexts.length > 0;
        },
        opened() {
            return this.openIds?.includes(this.item.Id);
        }
    },
    methods: {
      getLocalized(ru, kk) {
        return this.$i18n.locale === 'kk' ? kk : ru;
      }
    }
  }
  </script>